<template>
  <div class="userindex">
    <div class="van-content">
      <div class="userbanner">
        <router-link to="/user/personal">
          <img class="userbox-setting" src="./../../assets/img/sz.svg" alt="" />
        </router-link>
        <div class="userbox">
          <router-link to="/user/personal">
            <img
              v-if="this.$store.state.userCount.image == null"
              :src="
                this.$store.state.userCount.user_icon == null
                  ? '/static/images/userheaderimg.png'
                  : this.$store.state.userCount.user_icon
              "
              onerror="src='/static/images/userheaderimg.png'"
              class="head-portrait"
            />
            <img
              :src="this.$store.state.userCount.image"
              v-if="this.$store.state.userCount.image != null"
              onerror="src='/static/images/userheaderimg.png'"
              class="head-portrait"
            />
          </router-link>
          <div class="userbox-info">
            <div>
              <span class="user-name">{{ name }}</span>
              <span v-if="$common.getMallUrl('kmzhfl')">{{ $store.state.userCount.realname }}</span>
            </div>
            <div class="user-integral">
              <img src="./../../assets/img/user-jf.png" alt="" />
              {{ unit }}:
              <span
                v-html="
                  this.$store.state.userCount.point == null
                    ? '0'
                    : this.$store.state.userCount.point
                "
              ></span>
            </div>
          </div>
        </div>

        <div class="ordercell">
          <router-link to="/user/myorder?type=0">
            <div class="ordercell-my">
              <span>我的订单</span>
              <div class="my-right">
                <span class="ft12 col-999">全部订单</span>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
              </div>
            </div>
          </router-link>
          <div>
            <van-tabbar class="user-order-tab">
              <van-tabbar-item to="/user/myorder/payorder?type=1">
                <span>待付款</span>
                <template slot="icon" slot-scope="props">
                  <div class="navimgbox">
                    <img src="./../../assets/img/dfh.png" />
                  </div>
                </template>
              </van-tabbar-item>
              <van-tabbar-item to="/user/myorder/sendorder?type=2">
                <span>待发货</span>
                <template slot="icon" slot-scope="props">
                  <div class="navimgbox">
                    <img src="./../../assets/img/dfh.png" />
                  </div>
                </template>
              </van-tabbar-item>
              <van-tabbar-item to="/user/myorder/takeorder?type=3">
                <span>已发货</span>
                <template slot="icon" slot-scope="props">
                  <div class="navimgbox">
                    <img src="./../../assets/img/yfh.png" />
                  </div>
                </template>
              </van-tabbar-item>
              <van-tabbar-item to="/user/myorder/finishorder?type=4">
                <span>已取消</span>
                <template slot="icon" slot-scope="props">
                  <div class="navimgbox">
                    <img src="./../../assets/img/yqx.png" />
                  </div>
                </template>
              </van-tabbar-item>
            </van-tabbar>
          </div>
        </div>
      </div>

      <div class="message-mist">
        <!-- <router-link to="/user/recharge">
          <div class="integralTop-up">
            <div class="up-left">
              <span>{{ unit }}卡充值</span>
              <h3>如e卡充值</h3>
            </div>
            <div class="up-right">立即购买</div>
          </div>
        </router-link> -->

        <div class="integralTop-two">
          <router-link
            :style="{ flex: this.$store.state.webCount.send_status == 0 ? 1 : '' }"
            v-if="this.$store.state.webCount.buy_point === 1"
            to="/user/buypoints"
          >
            <div
              class="two-cont"
              :style="{ flex: this.$store.state.webCount.send_status == 0 ? 1 : '' }"
            >
              <img src="./../../assets/img/jfgm.svg" alt="" />
              <div class="two-cont-right">
                <h3>{{ unit }}购买</h3>
                <span>立即购买</span>
              </div>
            </div>
          </router-link>
          <router-link
            :style="{ flex: $store.state.webCount.buy_point != 1 ? 1 : '' }"
            v-if="this.$store.state.webCount.send_status == 1"
            to="/user/presented"
          >
            <div class="two-cont" :style="{ flex: this.$store.state.webCount.buy_point == 0 ? 1 : '' }">
              <img src="./../../assets/img/jfzz.svg" alt="" />
              <div class="two-cont-right">
                <h3>{{ unit }}转赠</h3>
                <span>立即转赠</span>
              </div>
            </div>
          </router-link>
        </div>

        <div>
          <router-link to="/user/mymoney" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/wdjf.png" alt="" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">我的{{ $common.cardName().type ? '金额': unit }}</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link>
          <!-- <router-link
            v-if="this.$store.state.webCount.buy_point === 1"
            to="/user/buypoints"
            class="van-cell van-hairline"
          >
            <div class="van-cell__title">
              <img src="/static/images/userindex2.png" />
            </div>
            <div class="van-cell__cont">
              <span>购买{{ unit }}</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link> -->
          <router-link to="/user/collect" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/wdsc.png" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">我的收藏</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link>
          <router-link to="/user/mynews" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/wdxi.png" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">文章列表</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link>
          <router-link to="/user/recharge" class="van-cell van-hairline" v-if="cardStatus==1">
            <div class="van-cell__title">
              <img src="/static/images/userindex4.png" />
            </div>
            <div class="van-cell__cont">

              <span>{{cardName}}充值</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link>
          <!-- <router-link
            v-if="this.$store.state.webCount.send_status == 1"
            to="/user/presented"
            class="van-cell van-hairline"
          >
            <div class="van-cell__title">
              <img src="/static/images/userindex5.png" />
            </div>
            <div class="van-cell__cont">
              <span>{{ unit }}转赠</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link> -->
        </div>
      </div>

      <div class="message-mist" style="margin-top: 0.2rem; border-radius: 0">
        <div>
          <div class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/bdwx.png" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">绑定微信</span>
              <span
                class="van-cell__cont-right"
                @click="relieve()"
                v-if="this.$store.state.userCount.image != null"
              >
                <span class="ft12">已绑定</span>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
              </span>
              <span
                class="van-cell__cont-right"
                @click="bang()"
                v-if="this.$store.state.userCount.image == null"
              >
                <span class="ft12">未绑定</span>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
              </span>
            </div>
          </div>
          <router-link to="/user/mysites" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/shdz.png" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">收货地址管理</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link>
          <!-- <router-link to="/user/personal" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/sz.svg" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">个人设置</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link> -->
          <a :href="'tel:' + this.$store.state.webCount.service_tell" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/kfrx.png" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">客服热线</span>
              <div class="van-cell__value">
                <span class="tell" style="position: relative; top: -0.03rem">
                  {{ this.$store.state.webCount.service_tell }}
                </span>
              </div>
            </div>
          </a>
          <router-link to="/user/feedback" class="van-cell van-hairline">
            <div class="van-cell__title">
              <img src="./../../assets/img/yjfk.png" />
            </div>
            <div class="van-cell__cont">
              <span class="van-cell__cont-left">意见反馈</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
          </router-link>
        </div>
      </div>

      <van-button size="large" class="out-login" @click="outLogin"> 退出登录 </van-button>
    </div>
    <!--底部导航-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import FooterNav from "@/components/footernav";
import store from "../../vuex/store";
import md5 from "js-md5";
export default {
  name: "User",
  components: {
    FooterNav
  },
  store,
  data() {
    return {
      datas: ""
    };
  },
  computed: {
    name: function() {
      if (this.$store.state.userCount.user_name != "") {
        return this.$store.state.userCount.user_name;
      } else if (this.$store.state.userCount.wechat_name != null) {
        return this.$store.state.userCount.wechat_name;
      } else {
        return this.$store.state.username;
      }
    },
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    cardStatus: function() {
      return this.$store.state.webCount.card_status;
    },
    cardName: function() {
      return this.$store.state.webCount.card_name;
    }
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    relieve: function() {
      this.$router.push({ name: "Weixin" });
    },
    bang: function() {
      // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
      // var ts = new Date();
      // ts = new Date(ts).getTime();
      // ts =ts/1000
      // var apiKey = '1106e4d408248208';
      // var securityKey ='D5695EBCCF795D68';
      // var sign =md5(md5('apiKey='+apiKey+'securityKey='+securityKey+'timeStamp='+ts));
      // var mallid=localStorage.getItem("mallid");
      // var host= window.location.host
      // var isUser = localStorage.getItem("BLHuser")
      // var root = process.env.PAY_URL
      // window.location.href= root + '/user/wechat/binding?id_example='+mallid+'&url='+host+'&token_user='+isUser+'&timeStamp='+ts+'&apiKey='+apiKey+'&sign='+sign;

      var isUser = localStorage.getItem("BLHuser");
      var root = process.env.BIND_URL;
      var backurl = window.location.origin + "/user";
      backurl = encodeURIComponent(backurl);
      window.location.href =
        root + "?reurl=" + backurl + "&token_user=" + isUser;
    },
    outLogin: function() {
      var mallid = localStorage.getItem("mallid");
      localStorage.clear();
      localStorage.setItem("mallid", mallid);
      this.$router.push({ name: "NoteLogin" });
      this.$store.commit("userInfo");
    }
  },
  mounted() {
    if (this.$route.query.suc == 1 && localStorage.getItem("suc") != 1) {
      localStorage.setItem("suc", 1);
      this.$toast("微信绑定成功");
    }
    this.$store.commit("userInfo");
  }
};
</script>

<style lang="less" scoped>
.userindex {
  min-height: 100vh;
  background: #f5f5f5;

  .van-content {
    padding-top: 0;

    .van-cell__right-icon {
      color: rgba(38, 38, 38, 0.3) !important;
      font-weight: bold;
    }

    .userbanner {
      width: 100%;
      height: 4.86rem;
      border-radius: 0rem 0rem 0.24rem 0.24rem;
      box-sizing: border-box;
      padding: 0 0.4rem;
      margin-bottom: 0.2rem;
      background-image: url("./../../assets/img/user-bg.png");
      background-size: 100%;
      background-repeat: no-repeat;
      overflow: hidden;
      position: relative;

      .userbox-setting {
        width: 0.48rem;
        height: 0.48rem;
        position: absolute;
        top: 0.3rem;
        right: 0.4rem;
      }

      .userbox {
        padding-top: 0.66rem;
        padding-bottom: 0.4rem;
        display: flex;
        align-items: center;

        .head-portrait {
          width: 1.08rem;
          height: 1.08rem;
          border-radius: 50%;
          object-fit: cover;
        }

        .userbox-info {
          margin-left: 0.3rem;
          .user-name {
            font-size: 0.32rem;
            font-weight: 500;
            color: #262626;
            line-height: 0.44rem;
          }

          .user-integral {
            display: inline-block;
            height: 0.36rem;
            background: linear-gradient(270deg, #e7c3a0 0%, #fde9de 100%);
            border-radius: 0.16rem;
            padding: 0 0.2rem 0 0.5rem;
            font-size: 0.26rem;
            font-weight: 400;
            color: #9e672e;
            line-height: 0.36rem;
            position: relative;
            margin-top: 0.05rem;

            img {
              width: 0.44rem;
              height: 0.44rem;
              position: absolute;
              left: -0.02rem;
              top: -0.05rem;
            }

            span {
              font-size: 0.26rem;
              font-weight: 400;
              color: #9e672e;
              line-height: 0.36rem;
            }
          }
        }
      }

      .ordercell {
        background-color: rgba(0, 0, 0, 0);

        .ordercell-my {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 0.4rem;
          margin-bottom: 0.4rem;

          span {
            font-size: 0.3rem;
            font-weight: bold;
            color: #262626;
            line-height: 0.42rem;
          }

          .my-right {
            display: flex;
            align-items: center;

            span {
              font-size: 0.24rem;
              font-weight: 400;
              color: #929292;
              line-height: 0.42rem;
            }
          }
        }

        .user-order-tab {
          background-color: rgba(0, 0, 0, 0);
          position: relative;
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 0 0.2rem;

          &::after {
            border: none;
          }

          .navimgbox {
            width: 0.64rem;
            height: 0.64rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .van-tabbar-item {
            flex: none;
          }

          .van-tabbar-item--active {
            color: #262626;
          }

          .van-tabbar-item__text {
            font-size: 0.26rem;
            font-weight: 400;
            color: #262626;
            line-height: 0.36rem;
          }
        }
      }
    }

    .message-mist {
      border-radius: 0.24rem 0.24rem 0rem 0rem;
      overflow: hidden;
      background-color: #fff;
      padding-top: 0.2rem;

      .integralTop-up {
        width: calc(100% - 0.4rem);
        height: 1.6rem;
        background: #e23130;
        border-radius: 0.16rem;
        margin: 0 auto;
        background-image: url("./../../assets/img/jf-zs.png");
        background-size: 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.4rem;

        .up-left {
          span {
            font-size: 0.24rem;
            font-weight: 600;
            color: #ffffff;
            line-height: 0.34rem;
          }

          h3 {
            font-size: 0.44rem;
            font-weight: 600;
            color: #ffffff;
            line-height: 0.6rem;
          }
        }

        .up-right {
          width: 1.64rem;
          height: 0.6rem;
          background: linear-gradient(270deg, #e7c3a0 0%, #fde9de 100%);
          border-radius: 0.36rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #a36e37;
          line-height: 0.6rem;
          text-align: center;
        }
      }

      .integralTop-two {
        box-sizing: border-box;
        padding: 0.2rem 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .two-cont {
          flex: 1;
          min-width: 3.44rem;
          height: 1.32rem;
          background: #f7f7f7;
          border-radius: 0.16rem;
          box-sizing: border-box;
          padding: 0.26rem;
          display: flex;

          img {
            width: 0.8rem;
            height: 0.8rem;
          }

          .two-cont-right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 0.18rem;

            h3 {
              font-size: 0.28rem;
              font-weight: 400;
              color: #262626;
              line-height: 0.4rem;
            }

            span {
              font-size: 0.24rem;
              font-weight: 400;
              color: #929292;
              line-height: 0.4rem;
            }
          }
        }
      }

      .van-cell {
        display: flex;
        align-items: center;
        position: relative;
        .van-cell__title {
          width: 0.48rem;
          height: 0.48rem;
          flex: none;
          display: flex;
          align-items: center;

          img {
            width: 100%;
            height: 100%;
          }
        }

        &:last-child {
          .van-cell__cont {
            &::after {
              height: 0;
            }
          }
        }

        .van-cell__cont {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 0.26rem;

          .van-cell__cont-left {
            font-size: 0.28rem;
            font-weight: 400;
            color: #262626;
          }

          .van-cell__cont-right {
            display: flex;
            align-items: center;
            font-size: 0.24rem;
            font-weight: 400;
            color: #929292;
          }

          &::after {
            content: "";
            width: 100%;
            height: 1px;
            position: absolute;
            bottom: 0;
            display: block;
            background-color: rgba(242, 242, 242, 1);
          }
        }

        &::after {
          border: none;
        }
      }
    }

    .out-login {
      width: 92%;
      height: 0.96rem;
      background: #fdf5f5;
      border-radius: 0.5rem;
      border: 1px solid #e23331;
      font-size: 0.3rem;
      font-weight: 500;
      color: #e23331;
      line-height: 0.96rem;
      text-align: center;
      margin: 0.4rem auto;
      margin-left: 4%;
      .van-button__content {
        color: #e23331;
      }
    }
  }
  .tell {
    vertical-align: -webkit-baseline-middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue